module.exports = __webpack_public_path__ + "static/media/slideshow_6.71f25ef0.png";